import React from 'react';
import { Database, Columns, AlertTriangle, Hash, CheckCircle, XCircle } from 'lucide-react';

const SchemaOverview = ({ stats, tableName }) => {
  const completenessRate = stats.totalRows > 0 
    ? (((stats.totalRows * stats.totalColumns - stats.totalNullValues) / (stats.totalRows * stats.totalColumns)) * 100).toFixed(1)
    : 0;

  const cards = [
    {
      title: 'Total Rows',
      value: stats.totalRows.toLocaleString(),
      subtitle: 'Records in table',
      icon: Database,
      color: 'text-blue-400',
      bgColor: 'bg-blue-900/20',
      borderColor: 'border-blue-700/50'
    },
    {
      title: 'Total Columns',
      value: stats.totalColumns.toLocaleString(),
      subtitle: 'Schema fields',
      icon: Columns,
      color: 'text-green-400',
      bgColor: 'bg-green-900/20',
      borderColor: 'border-green-700/50'
    },
    {
      title: 'Null Values',
      value: stats.totalNullValues.toLocaleString(),
      subtitle: 'Missing data points',
      icon: AlertTriangle,
      color: 'text-amber-400',
      bgColor: 'bg-amber-900/20',
      borderColor: 'border-amber-700/50'
    },
    {
      title: 'Avg Unique Values',
      value: stats.avgUniqueValues.toLocaleString(),
      subtitle: 'Per column',
      icon: Hash,
      color: 'text-purple-400',
      bgColor: 'bg-purple-900/20',
      borderColor: 'border-purple-700/50'
    },
    {
      title: 'Data Completeness',
      value: `${completenessRate}%`,
      subtitle: 'Non-null rate',
      icon: completenessRate >= 95 ? CheckCircle : XCircle,
      color: completenessRate >= 95 ? 'text-green-400' : 'text-amber-400',
      bgColor: completenessRate >= 95 ? 'bg-green-900/20' : 'bg-amber-900/20',
      borderColor: completenessRate >= 95 ? 'border-green-700/50' : 'border-amber-700/50'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {cards.map((card, index) => (
        <div 
          key={index}
          className={`card p-6 border-l-4 ${card.borderColor} ${card.bgColor} hover:scale-105 transition-all duration-200 hover:shadow-2xl`}
          style={{ animationDelay: `${index * 50}ms` }}
        >
          <div className="flex flex-col">
            <div className="flex items-center justify-between mb-3 h-8">
              <p className="text-xs uppercase tracking-wider text-gray-600 dark:text-marble-400 flex items-center gap-2 leading-tight transition-colors">
                <card.icon className={`h-4 w-4 ${card.color} flex-shrink-0`} />
                <span>{card.title}</span>
              </p>
            </div>
            <p className="text-3xl font-bold text-gray-900 dark:text-primary-200 mb-2 font-mono whitespace-nowrap overflow-hidden text-ellipsis transition-colors">
              {card.value}
            </p>
            <p className="text-xs text-gray-500 dark:text-marble-500 transition-colors">
              {card.subtitle}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SchemaOverview;
